import { ComponentType } from 'react';
import { NodeViewProps } from '@tiptap/core';

export type InlineBoardLinkOptions = {
    clickableLinksWhenEditable: boolean;
    dispatchFetchInlineBoardLinkDetails: DispatchFetchInlineBoardLinkDetails;
    urlOrigin: string;
    addSpaceOnCreation: boolean;
    NodeViewResolvedContent?: ComponentType<NodeViewProps>;
    onInsertedFromPaste?: () => void;
};

export enum InlineBoardLinkStatus {
    initial = 'initial',
    resolved = 'resolved',
}

export type InlineBoardLinkDetails = {
    url: string;
    boardId: string;
    permissionId?: string;
    title: string;
    color: string;
};

export type InlineBoardLinkAttributes = Omit<InlineBoardLinkDetails, 'permissionId'> & {
    permissionId: string;
    status: string;
};

export type FetchInlineBoardLinkDetailsResponse = Promise<Partial<InlineBoardLinkDetails> | null>;
export type DispatchFetchInlineBoardLinkDetails = (
    elementId: string,
    permissionId?: string,
) => FetchInlineBoardLinkDetailsResponse;
